/**
 * Remove falsey value, and convert string boolean to boolean
 * @date 2025/03/21
 * @param obj
 * @returns
 */
export const filterOutFalsyValues = (obj: Record<string, any>) => {
  return Object.keys(obj).reduce(
    (filtered, key) => {
      if (obj[key]) {
        filtered[key] = obj[key];
      }
      // @2025/03/21
      if (obj[key] === 'true') {
        filtered[key] = true;
      }
      // @2025/03/21
      if (obj[key] === 'false') {
        filtered[key] = false;
      }

      return filtered;
    },
    {} as Record<string, any>
  );
};
